interface SEOSchemaProps {
  schemas: Record<string, unknown>[];
}

export default function SEOSchema({ schemas }: SEOSchemaProps) {
  const jsonLd = schemas.length === 1 ? schemas[0] : schemas;

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}